"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PusherAdapter = void 0;
const pusher_js_1 = __importDefault(require("pusher-js"));
const lodash_1 = require("lodash");
const Adapter_1 = require("./Adapter");
const Types_1 = require("./Types");
const ParserService_1 = require("./ParserService");
const decompress_1 = __importDefault(require("./utility/decompress"));
class PusherAdapter extends Adapter_1.Adapter {
    constructor(options, adapterOptions) {
        super(options);
        this.channels = [];
        this.adapterOptions = adapterOptions;
        this.setName();
        this.addInitialChannels();
    }
    addInitialChannels() {
        this.addChannel(Types_1.ChannelType.Product, this.options.productId);
    }
    getChannelNamespace() {
        let namespace = 'NSoft';
        if (this.adapterOptions.usePlatformNamespace && this.options.platformName) {
            namespace = `${namespace}.${lodash_1.upperFirst(this.options.platformName)}`;
        }
        return namespace;
    }
    setListeners() {
        if (this.instance) {
            this.instance.connection.bind('error', (event) => {
                if (event.error && event.error.data && event.error.data.code === 4004) {
                    console.warn('[BusService]: Account over limit.');
                }
            });
        }
    }
    subscribe(channelId) {
        if (this.instance) {
            const channel = this.instance.subscribe(channelId);
            channel.bind_global((event, data) => {
                if (!event.startsWith('pusher:')) {
                    // Assuming gzip compression
                    const messageData = data.compressed
                        ? { ...data, data: decompress_1.default(data.data) }
                        : data;
                    ParserService_1.parseAndDispatchEvent(event, messageData, this.useCommonEventName, this.name, this.options.proxyEvents, this.options.bounceToFrames);
                }
            });
        }
    }
    subscribeAll() {
        this.channels.forEach((channelId) => {
            this.subscribe(channelId);
        });
    }
    unsubscribe(channelId) {
        if (this.instance) {
            this.instance.unsubscribe(channelId);
        }
    }
    unsubscribeAll() {
        this.channels.forEach((channelId) => {
            this.unsubscribe(channelId);
        });
    }
    setName() {
        this.name = Types_1.Adapters.PusherAdapter;
    }
    connect() {
        this.instance = new pusher_js_1.default(this.adapterOptions.key, {
            cluster: lodash_1.defaultTo(this.adapterOptions.cluster, 'eu'),
            authEndpoint: this.adapterOptions.authEndpoint,
            disabledTransports: lodash_1.defaultTo(this.adapterOptions.disabledTransports, []),
        });
        this.setListeners();
        this.subscribeAll();
    }
    disconnect() {
        if (this.instance) {
            this.unsubscribeAll();
            this.instance.disconnect();
        }
    }
    reconnect() {
        if (this.instance && this.instance.connection.state !== 'connected') {
            this.instance.connect();
        }
    }
    addChannel(channelType, channelName) {
        const optionalChannelName = !lodash_1.isNil(channelName) ? `.${channelName}` : '';
        const channelId = `${this.getChannelNamespace()}.${channelType}${optionalChannelName}`;
        if (this.channels.findIndex((n) => n === channelId) < 0) {
            this.channels.push(channelId);
            this.subscribe(channelId);
        }
    }
    removeChannel(channelType, channelName) {
        const channelId = `${this.getChannelNamespace()}.${channelType}.${channelName}`;
        const channelIndex = this.channels.findIndex((n) => n === channelId);
        if (channelIndex >= 0) {
            this.channels.splice(channelIndex, 1);
            this.unsubscribe(channelId);
        }
    }
    sendMessage(message) {
        console.warn(`${this.name}: ${Types_1.BusErrors.MethodNotImplementedError}`, message);
    }
    getState(message) {
        console.warn(`${this.name}: ${Types_1.BusErrors.MethodNotImplementedError}`, message);
        return new Promise((resolve) => resolve(undefined));
    }
}
exports.PusherAdapter = PusherAdapter;
//# sourceMappingURL=PusherAdapter.js.map